export abstract class PushService {
  abstract init(): Promise<void>;
}
